(ns app.survey.sub
  (:require
   [re-frame.core :as rf]))

(rf/reg-sub
 ::db
 (fn [db]
   db))

(rf/reg-sub
 ::tenant
 (fn [db]
   (get-in db [::tenant])))

(rf/reg-sub
 ::survey-access
 (fn [db]
   (get-in db [::survey-access])))

(rf/reg-sub
 ::invited-email
 (fn [db]
   (get-in db [::invited-email])))

(rf/reg-sub
 ::phone-number
 (fn [db]
   (get-in db [::phone-number])))

(rf/reg-sub
 ::logged-in-email
 (fn [db]
   (get-in db [::logged-in-email])))

(rf/reg-sub
 ::last-sms-sent
 (fn [db]
   (get-in db [::last-sms-sent])))

(rf/reg-sub
 ::last-email-sent
 (fn [db]
   (get-in db [::last-email-sent])))

(rf/reg-sub
 ::auth-type
 (fn [db]
   (get-in db [::auth-type])))


(rf/reg-sub
 ::sharing-type
 (fn [db]
   (get-in db [::sharing-type])))

(rf/reg-sub
 ::survey-id
 (fn [db]
   (get-in db [::survey-id])))

(rf/reg-sub
 ::survey-template
 (fn [db]
   (get-in db [::survey-template])))

(rf/reg-sub
 ::accessible-surveys
 (fn [db]
   (get-in db [::accessible-surveys])))

(rf/reg-sub
 ::processing?
 (fn [db]
   (get-in db [::processing?])))
